import { ReactNode } from 'react';
import { TitleNumber } from '../TitleNumber/TitleNumber';
import styles from './Title.module.css';

interface ITitle {
  children: ReactNode;
  number?: number;
}

export const Title = ({ children, number }: ITitle) => {
  return (
    <div className={styles.title}>
      {number && <TitleNumber n={number} />}
      {children}
    </div>
  );
};
